import { Outlet } from 'react-router-dom';
import { InvoiceIntakeSidebar } from './InvoiceIntakeSidebar';
import { Navbar } from './Navbar';
import { MobileMenuProvider } from '@/context/MobileMenuContext';

export function InvoiceIntakeLayout() {
  return (
    <MobileMenuProvider>
      <div className="flex h-screen flex-col overflow-hidden bg-gray-50">
        <Navbar />
        <div className="flex flex-1 overflow-hidden">
          <InvoiceIntakeSidebar />
          <main className="flex-1 overflow-y-auto p-6 relative z-0">
            <Outlet />
          </main>
        </div>
      </div>
    </MobileMenuProvider>
  );
}
